import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";

export const useArchiveWidget = () => {
  const router = useRouter();
  const [isInitialized, setIsInitialized] = useState(false);

  const initializeArchiveWidget = useCallback((token, locale, demo) => {
    const DB_URL = "https://widget.datablocks.se/api/rose";

    window._MF = {
      widget: "archive",
      token: token,
      data: [],
      url: DB_URL,
      ready: false,
      render: function () {
        this.ready = true;

        const archiveElement = document.getElementById("archive-module");
        if (archiveElement) {
          setTimeout(() => {
            archiveElement.style.opacity = "1";
          }, 0);
        }
      },
      push: function (conf) {
        this.data.push(conf);
      },
    };

    window._MF.push({
      query: "#archive-module",
      widget: "archive",
      locale: locale,
      token: token,
      demo: demo,
    });

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `${DB_URL}/assets/js/loader-v4.js`;
    document.body.appendChild(script);

    setIsInitialized(true);
  }, []);

  const cleanupArchiveWidget = useCallback(() => {
    delete window._MF;

    const scripts = document.querySelectorAll('script[src*="loader-v4.js"]');
    scripts.forEach((script) => script.remove());

    setIsInitialized(false);
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      if (isInitialized) {
        cleanupArchiveWidget();
      }
    };

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router, isInitialized, cleanupArchiveWidget]);

  return { initializeArchiveWidget, cleanupArchiveWidget };
};
